import { Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class ExcludedCorp extends DexResourceModel {

    @Field(String)
    public corpId: string = '';


    constructor(data?: any) {
        super();
        this.mapData(data);
    }

}
